import React from "react";
import energyImg from "../assets/energy.webp"; // Replace with your actual image path
import { motion } from "framer-motion";
import smartGrid from "../assets/smart-grid.png";
import energyAnalytics from "../assets/energy-analytics.png";
import predictiveMaintenance from "../assets/predictive-maintenance.png";
import remoteAsset from "../assets/remote-asset.png";
import renewable from "../assets/renewable.png";
import realtimeIcon from "../assets/icon-realtime.svg";
import efficiencyIcon from "../assets/icon-efficiencyy.svg";
import automationIcon from "../assets/icon-automationn.svg";
import costIcon from "../assets/icon-cost.svg";
import sustainabilityIcon from "../assets/icon-sustainability.svg";
import industrialIcon from "../assets/icon-industrial.svg";
import gridIcon from "../assets/icon-gridd.svg";
import buildingIcon from "../assets/icon-building.svg";
import renewableIcon from "../assets/icon-renewable.svg";
import buildingImage from "../assets/choose-us-building.webp";
import iconShield from "../assets/icon-shield.svg";
import iconPuzzle from "../assets/icon-puzzle.svg";
import iconChip from "../assets/icon-chip.svg";
import { useNavigate } from 'react-router-dom'; 
import inst from "../assets/Ins.png";
import face from "../assets/Face.png";
import you from "../assets/You.png";
import lin from "../assets/Lin.png";
import twi from "../assets/Twi.png";
import news from "../assets/News.png";
import phone from "../assets/phone.png";
import mail from "../assets/Mail.png";
import loc from "../assets/Loc.png";
import nlen from "../assets/Nlen.svg";
import user from "../assets/user.png";  
import { Helmet } from "react-helmet";

import { toast, ToastContainer } from "react-toastify";

import { useState, useEffect,useRef } from "react";

const EnergyHero = () => {
const FeatureCard = ({ image, title, bgColor, className = "" }) => (
  <div
    className={`rounded-[20px] p-6 flex flex-col items-center justify-center text-center ${bgColor} ${className}`}
    style={{ height: "172px", width: "100%" }}
  >
    <img
      src={image}
      alt={title}
      className="w-[80px] h-auto mb-2 object-contain"
    />
    <h3 className="text-base font-semibold text-black leading-tight">
      {title}
    </h3>
  </div>
);
    const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.2 },
  }),
};
const solutions = [
  {
    title: "Industrial Energy Management",
    desc: "Reduce operational costs with smart metering and equipment-level analytics.",
    icon: industrialIcon,
   
  },
  {
    title: "Smart Grid & Utilities",
    desc: "Empower grid automation, load forecasting, and energy theft detection.",
    icon: gridIcon,
    
  },
  {
    title: "Commercial Buildings",
    desc: "Enhance occupant comfort and energy savings with smart HVAC, lighting, and occupancy sensors.",
    icon: buildingIcon,
    
  },
  {
    title: "Renewable Energy IoT",
    desc: "Monitor solar/wind performance, optimize battery usage, and ensure grid compliance.",
    icon: renewableIcon,
    
  },
];

const features = [
  {
    title: "Smart Grid & Metering",
    image: smartGrid,
    bg: "bg-[#A8F29E]",
  },
  {
    title: "Energy Monitoring & Analytics",
    image: energyAnalytics,
    bg: "bg-[#1A1A1A] text-white",
  },
  {
    title: "Predictive Maintenance",
    image: predictiveMaintenance,
    bg: "bg-[#7883FF] text-white",
  },
  {
    title: "Remote Asset Management",
    image: remoteAsset,
    bg: "bg-[#D3DCFF]",
  },
  {
    title: "Renewable Integration",
    image: renewable,
    bg: "bg-[#F7E27D]",
  },
];
const featuress = [
  {
    icon: iconShield,
    title: "Proven IoT Platform",
    desc: "Built on a reliable, secure, and field-tested architecture powering energy systems across industries.",
    bg: "#E7FBE7",
    border: "#C5EBC4",
  },
  {
    icon: iconPuzzle,
    title: "Seamless API Integration",
    desc: "Easily connects with your existing systems for fast deployment and smooth data exchange.",
    bg: "#E5F0FF",
    border: "#D2E1FA",
  },
  {
    icon: iconChip,
    title: "Edge + Artificial Intelligence",
    desc: "Combines edge computing with AI to enable real-time decisions, faster response, and smarter automation.",
    bg: "#FFF4D9",
    border: "#FDE8B4",
  },
];
const benefits = [
  { line1: "Real-Time", line2: "Monitoring", icon: realtimeIcon },
  { line1: "Operational", line2: "Efficiency", icon: efficiencyIcon },
  { line1: "Automated", line2: "Control", icon: automationIcon },
  { line1: "Cost", line2: "Reduction", icon: costIcon },
  { line1: "Sustainability", line2: "", icon: sustainabilityIcon },
];
 const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
          // const [isServicesOpen, setIsServicesOpen] = useState(false);
          // const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
          // const [isCompanyOpen, setIsCompanyOpen] = useState(false);
        
          const toggleMobileMenu = () => {
            setIsMobileMenuOpen(!isMobileMenuOpen);
          };
        
          // const toggleServicesDropdown = () => {
          //   setIsServicesOpen(!isServicesOpen);
          // };
        
          // const toggleIndustriesDropdown = () => {
          //   setIsIndustriesOpen(!isIndustriesOpen);
          // };
        
          // const toggleCompanyDropdown = () => {
          //   setIsCompanyOpen(!isCompanyOpen);
          // };
    const [data, setData] = useState("");
      const [sessionid, setSessionid] = useState("");
      const [email, setEmail] = useState("");
      const [token, setToken] = useState("");
      useEffect(() => {
        fetch("https://api.app.mawalog.com/v1.2/website")
          .then((response) => response.json())
          .then((json) => {
            setData(json.data.captcha_code);
            setSessionid(json.data.session_id);
            setToken(json.data.token);
          })
          .catch((error) => console.error("Error fetching data:", error));
      }, []);
      useEffect(() => {
        const canvas = document.getElementById("captchaCanvas");
        if (canvas) {
          const ctx = canvas.getContext("2d");
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.font = "bold 18px Arial";
          ctx.fillStyle = "#00377B";
          ctx.fillText(data, 10, 22); // assuming 'data' holds the captcha string
        }
      }, [data]);
      const handleChange = (e) => {
        setEmail(e.target.value);
      };
     
       const canvasRef = useRef(null);
      const [captchaValue, setCaptchaValue] = useState(""); // text from API
      const [userCaptcha, setUserCaptcha] = useState("");
     
        /* ------------------------------------------------------------------- API fetch */
      const fetchCaptcha = async () => {
        try {
          const res = await fetch(
            "https://api.app.mawalog.com/v1.2/website"
          );
          const json = await res.json();
          setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
        } catch (err) {
          console.error("Error fetching captcha:", err);
        }
      };
     
      /* -- fetch once on mount ------------------------------------------------------- */
      useEffect(() => {
        fetchCaptcha();
      }, []);
     
      /* -- redraw every time captchaValue changes ------------------------------------ */
      useEffect(() => {
        if (!data) return; // nothing to paint yet
        const canvas = canvasRef.current;
        if (!canvas) return;
     
        const ctx = canvas.getContext("2d");
        const W = canvas.width;
        const H = canvas.height;
     
        /* ========= clear & background */
        ctx.clearRect(0, 0, W, H);
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, W, H);
     
        /* ========= random faint bezier curves (extra distortion) */
        for (let i = 0; i < 3; i++) {
          ctx.beginPath();
          ctx.moveTo(Math.random() * W, Math.random() * H);
          ctx.bezierCurveTo(
            Math.random() * W,
            Math.random() * H,
            Math.random() * W,
            Math.random() * H,
            Math.random() * W,
            Math.random() * H
          );
          ctx.lineWidth = 1 + Math.random(); // 1-2 px
          ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
          ctx.stroke();
        }
     
        /* ========= characters (uneven) */
        ctx.font = "bold 22px Arial";
        ctx.fillStyle = "#0A3A72";
        const chars = data.toString().split("");
     
        chars.forEach((ch, i) => {
          const angle = (Math.random() - 0.5) * 0.8; // ±23°
          const x = 8 + i * 14 + (Math.random() * 4 - 2);
          const y = 22 + (Math.random() * 6 - 3);
     
          ctx.save();
          ctx.translate(x, y);
          ctx.rotate(angle);
          ctx.fillText(ch, 0, 0);
          ctx.restore();
        });
     
        /* ========= dots */
        for (let i = 0; i < 45; i++) {
          ctx.beginPath();
          ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
          ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
          ctx.fill();
        }
      }, [data]);
     
      /* -- reload button click ------------------------------------------------------- */
      // const handleReload = () => {
      //   fetch("https://api.app.mawalog.com/v1.2/website")
      //     .then((response) => response.json())
      //     .then((json) => {
      //       setData(json.data.captcha_code);
      //       setSessionid(json.data.session_id);
      //       setToken(json.data.token);
      //     })
      //     .catch((error) => console.error("Error fetching data:", error));
      // };
      //   const handleSubscribe = async () => {
      //   try {
      //     const response = await fetch(
      //       "https://api-uat.mawalog.com/admin/v2/api/newsletter",
      //       {
      //         method: "POST",
      //         headers: {
      //           "Content-Type": "application/json",
      //           "X-CSRF-TOKEN": token,
      //         },
      //         body: JSON.stringify({
      //           session_id: sessionid,
      //           captcha: userCaptcha,
      //           email: email,
      //           type: "Mawalog",
      //         }),
      //       }
      //     );
     
      //     const result = await response.json();
      //     console.log("Response:", userCaptcha, " ", data);
      //     setEmail("");
      //    setUserCaptcha("");
      //     toast(result.message);
      //   } catch (error) {
      //     console.error("Error sending request:", error);
      //   }
      // };
      
      const [openDropdown, setOpenDropdown] = useState(null);
      const navRef = useRef(null);
    
      // Close dropdown on outside click
      useEffect(() => {
        const handleClickOutside = (event) => {
          if (navRef.current && !navRef.current.contains(event.target)) {
            setOpenDropdown(null);
          }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
      }, []);
    
      const toggleDropdown = (dropdown) => {
        setOpenDropdown(openDropdown === dropdown ? null : dropdown);
      };
      
      const navigate = useNavigate();
     
      const handleClick = () => {
        navigate("/Contact#contact-section");
      };
        const [isOpen, setIsOpen] = useState(false);
              
                // const toggleDropdown = () => {
                //   setIsOpen((prev) => !prev);
                // };
          
          
                const [isServicesOpen, setIsServicesOpen] = useState(false);
            const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
            const [isCompanyOpen, setIsCompanyOpen] = useState(false);
          
            // Toggle functions for dropdowns
            const toggleServicesDropdown = () => {
              setIsServicesOpen(!isServicesOpen);
              setIsIndustriesOpen(false);
              setIsCompanyOpen(false); // Close other dropdowns
            };
          
            const toggleIndustriesDropdown = () => {
              setIsIndustriesOpen(!isIndustriesOpen);
              setIsServicesOpen(false);
              setIsCompanyOpen(false); // Close other dropdowns
            };
          
            const toggleCompanyDropdown = () => {
              setIsCompanyOpen(!isCompanyOpen);
              setIsServicesOpen(false);
              setIsIndustriesOpen(false); // Close other dropdowns
            };
                const [word, setWord] = useState('Today');
          
            useEffect(() => {
              const interval = setInterval(() => {
                setWord((prev) => (prev === 'Today' ? 'Tomorrow' : 'Today'));
              }, 2000);
              return () => clearInterval(interval);
            }, []);


  const toggleSlider = () => {
    setIsOpen((prev) => !prev);
  };

    // Newsletter captcha refs/state (separate)
  const [submail, setSubmail] = useState("");
  const newsletterCanvasRef = useRef(null);
  const [newsCaptcha, setNewsCaptcha] = useState("");
  const [newsletterCaptcha, setNewsletterCaptcha] = useState({ code: "", sessionId: "", token: "" });
  const [newsletterUserCaptcha, setNewsletterUserCaptcha] = useState(""); // <-- new state for newsletter captcha input
  const [formError, setFormError] = useState("");
  const [formSuccess, setFormSuccess] = useState("");
  const handleReload = () => {
    fetchNewsletterCaptcha();
  };

  const fetchNewsletterCaptcha = async () => {
    try {
      const response = await fetch("https://api.app.mawalog.com/v1.2/website");
      const json = await response.json();
      if (json?.data) {
        setNewsletterCaptcha({ code: json.data.captcha_code, sessionId: json.data.session_id, token: json.data.token });
      }
    } catch (err) {
      console.error("Error fetching newsletter captcha:", err);
    }
  };

  useEffect(() => {
    // fetch both captchas on mount so both canvases are ready
    fetchNewsletterCaptcha();
  }, []);

  // Draw newsletter captcha whenever it changes
  useEffect(() => {
    if (!newsletterCaptcha?.code) return;
    const canvas = newsletterCanvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;

    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);

    // noise / curves
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.lineWidth = 1 + Math.random();
      ctx.stroke();
    }

    // draw characters
    const chars = newsletterCaptcha.code.toString().split("");
    ctx.fillStyle = "#0A3A72";
    const fonts = ["Arial", "Verdana", "Georgia", "Courier New", "Times New Roman"];
    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 1.2;
      const x = 8 + i * 12 + (Math.random() * 4 - 2);
      const y = 24 + (Math.random() * 6 - 3);
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.font = `bold ${16 + Math.floor(Math.random() * 6)}px ${fonts[Math.floor(Math.random() * fonts.length)]}`;
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });

    // dots
    for (let i = 0; i < 35; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [newsletterCaptcha]);
   const handleSubscribe = async (e) => {
  e?.preventDefault?.();

  // Basic email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!submail) {
    toast("Please enter an email address");
    return;
  }

  if (!emailRegex.test(submail)) {
    toast("Please enter a valid email address");
    return;
  }

  if (!newsletterUserCaptcha) {
    toast("Please enter the captcha");
    return;
  }

  try {
    const res = await fetch("https://api.app.mawalog.com/v1.2/newsletter", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": newsletterCaptcha.token || "", // use newsletter token
      },
      body: JSON.stringify({
        session_id: newsletterCaptcha.sessionId || "", // use newsletter session id
        captcha: newsletterUserCaptcha, // use newsletter captcha input
        email: submail,
        type: "Mawalog",
      }),
    });

    const result = await res.json();

    // On success clear inputs and reload captcha
    if (res.ok) {
      setSubmail("");
      setNewsletterUserCaptcha("");
      fetchNewsletterCaptcha();
    }

    toast(result.message || "Subscription response received");
  } catch (err) {
    console.error("Newsletter subscribe error:", err);
    toast("Subscription failed. Please try again.");
  }
};

  return (
    <>
     <Helmet>
        <title>IoT Energy Solutions | Smart & Sustainable Energy Management</title>
        <meta name="description" content="Optimize your energy systems with LENTERA’s IoT solutions. Enable real-time monitoring, predictive maintenance, smart grid management, and renewable energy integration for enhanced efficiency, cost reduction, and sustainable operations."/>
        <meta name="keywords" content="LENTERA energy IoT, automated energy control, real-time energy monitoring, sustainable energy solutions, AI-powered energy systems.
"/>
      </Helmet>
    <section className="w-full bg-[#10101E] py-20 px-4 sm:px-6">
  <div className="w-full max-w-[1312px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">
    
{/* LEFT CONTENT */}
    <motion.div
      className="w-full lg:w-[60%]"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      <p className="text-[#FFFFFF] font-semibold text-sm mb-3 uppercase tracking-wider">
        Energy
      </p>
      <h1 className="text-[#FFFFFF] text-[40px] md:text-[48px] leading-[52px] md:leading-[58px] font-extrabold mb-[24px]">
         Empowering the Future<br className="hidden lg:block" />
        of Energy with IoT
        
      </h1>
      <p className="text-[#FFFFFF] text-[16px] md:text-[18px] leading-[28px] md:leading-[30px] max-w-[600px]">
        Unlock smarter, cleaner, and more efficient energy systems through
        intelligent IoT technologies.
      </p>
    </motion.div>

    {/* RIGHT IMAGE */}
    <motion.div
      className="w-full lg:w-[40%] flex justify-center lg:justify-end"
      initial={{ opacity: 0, scale: 0.9 }}
      whileInView={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
      viewport={{ once: true }}
    >
      <img
            src={energyImg}
            alt="Energy IoT Illustration"
            className="w-[380px] sm:w-[460px] md:w-[520px] lg:w-full max-w-[600px] h-auto object-contain"
          />
    </motion.div>

  </div>
</section>


  

<section className="bg-[#FAFAFA] py-12 px-4 sm:px-6 lg:px-20">
  {/* Section Heading */}
 <div className="bg-[#f9f9f9] py-20">
  <div className="max-w-[1200px] mx-auto text-center px-4">
    {/* Top Badge */}
    <div className="inline-block px-4 py-2 bg-[#e5e5e5] text-gray-700 text-sm font-semibold rounded-full mb-4">
      OUR SERVICES
    </div>

    {/* Heading */}
    <h2 className="text-[36px] md:text-[48px] font-extrabold text-[#1a1a1a]">
      Key Benefits / Features
    </h2>

    {/* Description */}
    <p className="mt-4 text-lg md:text-xl text-gray-700 max-w-3xl mx-auto">
      We transform the energy sector with real-time insights, remote monitoring, and smart control to boost efficiency and reduce costs.
    </p>
  </div>
</div>

  {/* Cards Grid */}
  <div className="max-w-screen-xl mx-auto grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 auto-rows-auto">
    
    {/* Smart Grid & Metering */}
    <div className="bg-[#90EE90] rounded-3xl p-6 flex flex-col justify-center items-center text-center">
      <img
        src={smartGrid}
        alt="Smart Grid & Metering"
        className="w-full max-w-[264px] h-auto mb-4 object-contain"
      />
      <h4 className="text-lg font-semibold text-[#1A1A1A]">Smart Grid & Metering</h4>
    </div>

    {/* Energy Monitoring & Analytics */}
    <div className="bg-[#1A1A1A] text-white rounded-3xl p-6 flex flex-col justify-center items-center sm:col-span-2 lg:col-span-2">
      <h4 className="text-lg font-semibold mb-4">Energy Monitoring & Analytics</h4>
      <img
        src={energyAnalytics}
        alt="Energy Monitoring & Analytics"
        className="w-full max-w-[320px] h-auto object-contain"
      />
    </div>

    {/* Predictive Maintenance */}
    <div className="bg-[#6A6BFF] text-white rounded-3xl p-6 flex flex-col justify-center items-center text-center sm:row-span-2">
      <h4 className="text-lg font-semibold mb-4">Predictive Maintenance</h4>
      <img
        src={predictiveMaintenance}
        alt="Predictive Maintenance"
        className="w-full max-w-[360px] h-auto object-contain"
      />
    </div>

    {/* Remote Asset Management */}
    <div className="bg-[#DCE5FF] rounded-3xl p-6 flex flex-col justify-center items-center sm:col-span-2 lg:col-span-2">
      <img
        src={remoteAsset}
        alt="Remote Asset Management"
        className="w-full max-w-[272px] h-auto mb-4 object-contain"
      />
      <h4 className="text-lg font-semibold text-[#1A1A1A] text-center">
        Remote Asset <br /> Management
      </h4>
    </div>

    {/* Renewable Integration */}
    <div className="bg-[#FFE47E] rounded-3xl p-6 flex flex-col justify-center items-center text-center">
      <img
        src={renewable}
        alt="Renewable Integration"
        className="w-full max-w-[134px] h-auto mb-4 object-contain"
      />
      <h4 className="text-lg font-semibold text-[#1A1A1A]">Renewable Integration</h4>
    </div>
  </div>
</section>


   <section className="w-full bg-[#1C1C1C] text-white font-poppins px-6 md:px-12 py-20">
      {/* Header */}
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
          {/* Left Title Area */}
          <div className="flex-1">
            <div className="bg-[#2c2c2c] text-xs px-4 py-1 rounded-full font-medium inline-block mb-4">
              WHY IOT ENERGY?
            </div>
            <h2 className="text-white text-[32px] sm:text-[38px] lg:text-[44px] font-extrabold leading-tight">
              Why you need us for your <br /> business growth?
            </h2>
          </div>

          {/* Right Description */}
          <div className="flex-1 max-w-xl text-[14px] sm:text-[15px] text-[#DDDDDD] leading-[1.7]">
            IoT brings real-time visibility, smart automation, and data-driven insights to energy systems—enabling improved efficiency, reduced costs, and sustainable operations.
          </div>
        </div>

        {/* Card Section */}
        <div className="mt-14 bg-[#111111] rounded-[36px] px-4 sm:px-6 py-8 overflow-x-auto">
          <div className="flex flex-nowrap gap-5 sm:gap-6 min-w-max">
            {benefits.map((item, index) => (
              <div
                key={index}
                className="flex flex-col items-start bg-[#2a2a2a] px-5 py-5 rounded-2xl min-w-[185px] sm:min-w-[210px] text-left shadow-sm"
              >
                <img
                  src={item.icon}
                  alt={item.line1 + ' ' + item.line2}
                  className="w-[28px] h-[28px] mb-3"
                />
                <p className="text-sm sm:text-[15px] font-semibold leading-tight">
                  {item.line1} {item.line2 && <br />} {item.line2}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
    <section className="w-full bg-[#F6FAFF] py-16 px-4 sm:px-8 font-poppins">
      {/* Header */}
      <div className="text-center max-w-3xl mx-auto mb-12">
        <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4">
          Solutions We Offer
        </h2>
        <p className="text-sm sm:text-base text-gray-500">
          Smart solutions for energy efficiency and control. Optimized for
          industries, buildings, and utilities.
        </p>
      </div>

      {/* Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {solutions.map((item, index) => (
          <div
            key={index}
            className="bg-white rounded-[20px] p-6 shadow-md flex flex-col gap-4"
          >
            <img
              src={item.icon}
              alt={item.title}
              className="w-[58px] h-[58px] object-contain"
            />
            <h3 className="text-sm sm:text-base font-semibold text-gray-900 leading-tight">
              {item.title}
            </h3>
            <p className="text-sm text-gray-500 leading-relaxed">
              {item.desc}
            </p>
          </div>
        ))}
      </div>
    </section>
     <section className="bg-white py-16 px-4 sm:px-6 lg:px-20">
      <div className="max-w-screen-xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        
        {/* Left Content */}
        <div className="space-y-6">
          <h2 className="text-4xl sm:text-5xl font-extrabold text-[#1A1A1A]">Why Choose Us</h2>
          <p className="text-lg text-[#4B4B4B] max-w-xl">
            We combine intelligent IoT technology with deep energy expertise to deliver reliable, scalable, and future-ready solutions.
          </p>
          <img
            src={buildingImage}
            alt="Wind and Solar Energy"
            className="w-full max-w-[520px] object-contain mx-auto sm:mx-0"
          />
        </div>

        {/* Right Content */}
        <div className="flex flex-col gap-6 w-full">
          {/* Card 1 */}
          <div className="flex items-center bg-[#F0FFE9] rounded-3xl p-6 shadow-sm w-full">
            <img src={iconShield} alt="IoT Shield" className="h-12 w-12 mr-6" />
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full">
              <h4 className="text-lg font-semibold text-[#1A1A1A] mb-2 sm:mb-0 sm:w-1/3">Proven IoT Platform</h4>
              <p className="text-[#4B4B4B] text-sm sm:w-2/3">
                Built on a reliable, secure, and field-tested architecture powering energy systems across industries.
              </p>
            </div>
          </div>

          {/* Card 2 */}
          <div className="flex items-center bg-[#EAF1FF] rounded-3xl p-6 shadow-sm w-full">
            <img src={iconPuzzle} alt="API Icon" className="h-12 w-12 mr-6" />
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full">
              <h4 className="text-lg font-semibold text-[#1A1A1A] mb-2 sm:mb-0 sm:w-1/3">Seamless API Integration</h4>
              <p className="text-[#4B4B4B] text-sm sm:w-2/3">
                Easily connects with your existing systems for fast deployment and smooth data exchange.
              </p>
            </div>
          </div>

          {/* Card 3 */}
          <div className="flex items-center bg-[#FFF9E7] rounded-3xl p-6 shadow-sm w-full">
            <img src={iconChip} alt="AI Icon" className="h-12 w-12 mr-6" />
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full">
              <h4 className="text-lg font-semibold text-[#1A1A1A] mb-2 sm:mb-0 sm:w-1/3">Edge + Artificial Intelligence</h4>
              <p className="text-[#4B4B4B] text-sm sm:w-2/3">
                Combines edge computing with AI to enable real-time decisions, faster response, and smarter automation.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    
<div className="bg-[#111215] text-white">
   {/* Footer Section */}
   <footer className="px-4 sm:px-8 md:px-12 pt-12 pb-4">
     {/* Newsletter Section */}
     <div className="w-full bg-[#111215] max-w-[1312px] mx-auto rounded-[24px] md:rounded-[48px] px-4 sm:px-8 md:px-12 py-8 md:py-12 shadow-[0_25px_80px_0_rgba(0,0,0,0.05)] flex flex-col gap-10">
            {/* Top newsletter */}
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 w-full">
              {/* Left Side */}
              <div className="flex items-start md:items-center gap-4 md:gap-6">
                <img src={news} alt="newsletter" className="w-12 h-12 md:w-[80px] md:h-[80px]" />
                <h2 className="text-xl md:text-[28px] font-bold leading-tight">
                  Join our newsletter to <br className="hidden md:block" />
                  keep up to date with us!
                </h2>
              </div>

              <div className="flex flex-col items-center gap-4 w-full sm:w-[335px]">
                {/* Newsletter input */}
                <div
                  className="flex items-center bg-[#111215] border border-[#333] px-4 py-3 sm:px-6 sm:py-4 w-full"
                  style={{ borderRadius: "6px" }}
                >
                  <img src={user} alt="user icon" className="w-5 h-5 mr-3" />
                  <input
                    type="email"
                    value={submail}
                    onChange={(e) => setSubmail(e.target.value)}
                    placeholder="Enter your email"
                    className="bg-transparent outline-none text-white placeholder-gray-400 w-full text-sm"
                  />
                </div>


                {/* Captcha line (canvas + refresh + input + subscribe button) */}
                {/* Outer wrapper to center the row */}
                <div className="w-full flex justify-center">
                  <div className="flex items-center gap-3">
                    {/* Captcha canvas */}
                    <div className="captcha-box">
                      <canvas
                        ref={newsletterCanvasRef}
                        id="newsletterCaptchaCanvas"
                        width={60}
                        height={40}
                        style={{ borderRadius: "6px", overflow: "hidden" }} // Optional inline for extra assurance
                      />
                    </div>

                    {/* Refresh button */}
                    <button
                      onClick={handleReload}
                      style={{
                        background: "#07862B ",
                        color: "#fff",
                        border: "none",
                        padding: "6px",
                        borderRadius: "6px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="23 4 23 10 17 10"></polyline>
                        <polyline points="1 20 1 14 7 14"></polyline>
                        <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
                      </svg>
                    </button>

                    {/* Captcha input */}
                    <input
                      type="text"
                      placeholder="Enter captcha"
                      value={newsletterUserCaptcha}
                      onChange={(e) => setNewsletterUserCaptcha(e.target.value)}
                      className="captcha-input"
                    />

                    {/* Subscribe button */}
                    <button className="subscribe-button" onClick={handleSubscribe}>
                      Subscribe
                    </button>
                  </div>
                </div>

                <style>{`
  .captcha-box {
    width: 60px !important;
    height: 35px !important;
    border-radius: 6px !important;
    overflow: hidden !important;
    color :131519;
    background-color: #fff !important;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
 
  .captcha-input {
    padding: 11px 8px !important;
    border-radius: 6px !important;
    border: 1px solid #ccc !important;
    outline: none !important;
    width: 100px !important;
    background: #131519 !important;
    color: #fff !important;
    font-size: 10px !important;
  }
 
  .subscribe-button {
    padding: 10px 16px !important;
    border-radius: 8px !important;
    border: none !important;
    background: #07862B !important;
    color: #fff !important;
    font-weight: bold !important;
    font-size: 13px !important;
    cursor: pointer !important;
    white-space: nowrap !important;
  }
 
  @media(max-width:480px){
    .captcha-input { width: 70px !important; font-size: 12px !important; }
    .subscribe-button { padding: 8px 12px !important; font-size: 12px !important; }
  }
`}</style>

              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-gray-700 w-full" />

            {/* Main Footer Content */}
            <div className="flex flex-col lg:flex-row flex-wrap justify-between items-start w-full gap-8 text-[16px]">
              {/* Company Info */}
              <div className="w-full lg:w-[30%]">
                <a href="/" aria-label="Lentera Home">
                  <img src={nlen} alt="Lentera logo" className="mb-6" />
                </a>
                <p className="text-[#d4d4d4] leading-relaxed">
                  We are highly experienced in offering software development, mobile
                  application development, software consulting and project management
                  delivery.
                </p>
                {/* Social Icons */}
                <div className="flex gap-4 mt-6 flex-wrap">
                  <a href="https://www.instagram.com/lenteratechnologies/?hl=en" target="_blank" rel="noopener noreferrer">
                    <img src={inst} alt="Instagram" className="w-8 h-8" />
                  </a>
                  <a href="https://www.facebook.com/lenteratechnologies/?ref=pages_you_manage" target="_blank" rel="noopener noreferrer">
                    <img src={face} alt="Facebook" className="w-8 h-8" />
                  </a>
                  <a href="https://www.youtube.com/@lenteratechnologies" target="_blank" rel="noopener noreferrer">
                    <img src={you} alt="YouTube" className="w-8 h-8" />
                  </a>
                  <a href="https://in.linkedin.com/company/lenteratechnologies" target="_blank" rel="noopener noreferrer">
                    <img src={lin} alt="LinkedIn" className="w-8 h-8" />
                  </a>
                  <a href="https://x.com/lenteratech" target="_blank" rel="noopener noreferrer">
                    <img src={twi} alt="X" className="w-8 h-8" />
                  </a>
                </div>

              </div>

              {/* Services */}
              <div className="w-full sm:w-[45%] md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">OUR SERVICES</h4>
                <ul className="space-y-2 text-[#d4d4d4]">
                  <li><a href="/services/ai-services/" className="hover:text-white">AI services</a></li>
                  <li><a href="/services/web-development/" className="hover:text-white">Web development</a></li>
                  <li><a href="/services/mobile-app-development/" className="hover:text-white">Mobile app development</a></li>
                  <li><a href="/services/software-consulting/" className="hover:text-white">Software consulting</a></li>
                  <li><a href="/services/custom-development/" className="hover:text-white">Custom consulting</a></li>
                  <li><a href="/services/third-party-integration/" className="hover:text-white">Third party integration</a></li>
                  <li><a href="/services/enterprise-application/" className="hover:text-white">Enterprise Application</a></li>
                </ul>
              </div>


              {/* Insights */}
              <div className="w-full sm:w-[45%] md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">INSIGHTS</h4>
                <ul className="space-y-2 text-[#d4d4d4]">
                  <li><a href="https://blog.lentera.in/" className="hover:text-white">Blog</a></li>
                  <li><a href="https://www.lentera.in/careers/" className="hover:text-white">Careers</a></li>
                  <li><a href="https://blog.lentera.in/" className="hover:text-white">News</a></li>
                </ul>
              </div>

              {/* Contact */}
              <div className="w-full md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">CONTACT US</h4>
                <div className="flex items-start gap-3 mb-3">
                  <img src={phone} alt="phone" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Phone number</p>
                    <a href="tel:+914448563345" className="text-white font-medium text-sm hover:underline">
                      +91-44-4856-3345
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3 mb-3">
                  <img src={mail} alt="email" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Email address</p>
                    <a href="mailto:info@lenteratech.com" className="text-white font-medium text-sm hover:underline">
                      info@lenteratech.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <img src={loc} alt="location" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Location</p>
                    <a
                      href="https://www.google.com/maps?q=G1,+Plot+No+824+and+826,+3rd+Main+Rd,+Ram+Nagar+South,+Madipakkam,+Chennai,+Tamil+Nadu+600091"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white font-medium text-sm hover:underline block"
                    >
                      G1, Plot No, 824 and 826, 3rd<br />
                      Main Rd, Ram Nagar South,<br />
                      Madipakkam, Chennai,<br />
                      Tamil Nadu 600091
                    </a>
                  </div>
                </div>


              </div>
            </div>
          </div>
   </footer>
 
   {/* Bottom Section */}
  <div className="bg-[#23262E] border-t border-gray-700 text-sm text-[#ccc] flex flex-col md:flex-row justify-between items-center gap-2 py-4 px-4 sm:px-6 md:px-12 text-center md:text-left">
     <p>© 2025  Lentera Technologies Pvt Ltd. All rights reserved.</p>
     <div className="flex flex-wrap gap-4 justify-center md:justify-end">
       <a href="/terms-condition/" className="hover:underline">Terms and conditions</a>
       <a href="/privacy-policy/" className="hover:underline">Privacy Policy</a>
       <a href="/cookie-policy/" className="hover:underline">Cookies Policy</a>
       <a href="/copyright-information/" className="hover:underline">Copyright information</a>
     </div>
   </div>
 </div>
    </>
  );
};

export default EnergyHero;
